exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pictrue-imgs[data-v-4f88eea0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.banner-item[data-v-4f88eea0]{width:58px;margin-right:15px;margin-bottom:15px;height:58px;position:relative}.banner-item img[data-v-4f88eea0]{width:100%;height:100%}.banner-item .delete-icon[data-v-4f88eea0]{color:red;font-size:16px;position:absolute;right:-10px;top:-8px}", ""]);

// exports
